import customData from '../customData.json'

export const getMbookingProductList = (params) => {
    return fetch(`${customData.apiPath}/getMbookingProductList`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};

export const getMbookingProductAvaliableTimeslot = (params) => {
    return fetch(`${customData.apiPath}/getMbookingProductAvaliableTimeslot`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};

export const submitMbooking = (params) => {
    return fetch(`${customData.apiPath}/submitMbooking`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};

export const getMbookingRecordList = (params) => {
    return fetch(`${customData.apiPath}/getMbookingRecordList`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};


export const getMbookingRecord = (params) => {
    return fetch(`${customData.apiPath}/getMbookingRecord`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};

export const getMbookingProductTimeslotGroup = (params) => {
    return fetch(`${customData.apiPath}/getMbookingProductTimeslotGroup`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};

export const cancelMbooking = (params) => {
    return fetch(`${customData.apiPath}/cancelMbooking`, {
        method: 'POST',
        headers: {
        Accept: 'application/json',
        // 'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then((res) => res.json());
};
